import React, { useEffect, useRef, useState } from 'react';
import { Button, Collapse, Form, ListGroup } from 'react-bootstrap';
import ModalComponent from '../../../helper_components/ModalComponent';
import GrowLoader from '../../../layout/shared/GrowLoader';
import useUsersAndPermissionsListModal from '../customHooks/useUsersAndPermissionsListModal';
import Cookies from 'js-cookie';
import { spread } from 'lodash';

const UsersAndPermissionsListModal = ({
  isModalShowing,
  setModalShowing,
  document = {},
  expedientId,
  asign = {},
  setShowTransferModal,
  fromPanel = {},
  lastDocument = {},
  onPermissionsUpdated = {},
}) => {
  const specialPermissions = Cookies.getJSON('special_permissions_03');
  const canSaveDocumentWithOutusers = specialPermissions[0].omit_mandatory_visibility == 1;
  const {
    onPermissionToggled,
    isLoadingUsersPermissions,
    usersPermissions,
    onPostUsersPermissions,
    onUsersPermissionsToSearchInputChange,
    usersPermissionsToSearch,
    onSearchUserPermision,
    showConfirmModal,
    showCollapseForUserPermissions,
    setShowConfirmModal,
    usersPermissionsToSet,
  } = useUsersAndPermissionsListModal({
    setModalShowing,
    documentExpedientId: document.id ? document.id : expedientId,
    expedientId,
  });
  const usersWithPermissionsToSet = usersPermissionsToSet.some((user) => user.isPermissionEnabled);
  const canContinue =
    usersPermissions.length > 0 && usersPermissionsToSet.length > 0 && usersWithPermissionsToSet;

  const modifiedUserIds = usersPermissionsToSet.map((user) => user.id);
  const unmodifiedUsers = usersPermissions.filter((user) => !modifiedUserIds.includes(user.id));
  const allUsers = [...usersPermissionsToSet, ...unmodifiedUsers];
  const hasEnabledPermission =
    allUsers.length > 0 && allUsers.some((user) => user.isPermissionEnabled === true);

  const initialHasEnabledPermissionRef = useRef(null);

  useEffect(() => {
    if (initialHasEnabledPermissionRef.current === null && usersPermissions.length > 0) {
      initialHasEnabledPermissionRef.current = usersPermissions.some(
        (u) => u.isPermissionEnabled === true
      );
    }
  }, [usersPermissions]);

  const initialHasEnabledPermission = initialHasEnabledPermissionRef.current === true;

  const bodyModal = (
    <>
      <div>
        <Form
          onSubmit={onSearchUserPermision}
          className="d-flex justify-content-center align-items-center pb-3"
          style={{ borderBottom: '1px solid #e7e7e7', gap: '10px' }}
        >
          <Form.Group controlId="formBasicEmail" className="m-0">
            <Form.Control
              type="text"
              placeholder="Buscar usuario"
              style={{ borderRadius: '50px' }}
              onChange={onUsersPermissionsToSearchInputChange}
              value={usersPermissionsToSearch}
            />
          </Form.Group>
          <button type="submit" className="btn btn-outline-secondary rounded-circle">
            <i className="fas fa-search text-black-50"></i>
          </button>
        </Form>
        {isLoadingUsersPermissions ? (
          <div className="pt-3">
            <GrowLoader />
          </div>
        ) : usersPermissions.length > 0 ? (
          <>
            <ListGroup variant="flush">
              <ListGroup.Item
                className="d-flex justify-content-between align-items-center"
                style={{ gap: '20px' }}
              >
                <div className="d-flex justify-content-center flex-grow-1">Usuario</div>
                <div className="d-flex justify-content-center flex-grow-1">Fecha de acceso</div>
                <span className="ml-3 text-center" style={{ width: 'min-content' }}>
                  Acceso al documento
                </span>
              </ListGroup.Item>

              {usersPermissions.map((userPermissions) => (
                <>
                  <ListGroup.Item
                    key={userPermissions.id}
                    className="d-flex justify-content-between align-items-center"
                    style={{ borderTop: '1px solid #e7e7e7', gap: '20px' }}
                  >
                    <div>
                      <p className="m-0" style={{ fontSize: '12px' }}>
                        {userPermissions.fullname}
                      </p>
                      <p className="m-0" style={{ fontSize: '11px' }}>
                        {userPermissions.email}
                      </p>
                    </div>
                    <div className="d-flex justify-content-center flex-grow-1 ml-5">
                      <p
                        href="#"
                        onClick={() => showCollapseForUserPermissions(userPermissions)}
                        style={{
                          cursor: 'pointer',
                          fontSize: '12px',
                          color: '#1f79ff',
                          textDecoration: 'underline',
                        }}
                      >
                        {userPermissions.visibility_date}
                      </p>
                    </div>
                    <div className="pr-3">
                      <Form>
                        <Form.Check
                          type="switch"
                          id={`custom-switch-${userPermissions.id}`}
                          defaultChecked={userPermissions.isPermissionEnabled}
                          value={userPermissions.id}
                          onClick={onPermissionToggled}
                        />
                      </Form>
                    </div>
                  </ListGroup.Item>
                  <div className="d-flex justify-content-center">
                    <Collapse class name="w-100" id={`userPermissions-${userPermissions.id}`}>
                      <ListGroup>
                        <ListGroup.Item
                          className="d-flex justify-content-between align-items-center"
                          style={{ gap: '20px' }}
                        >
                          <div className="d-flex justify-content-center flex-grow-1">
                            <p
                              className="m-0"
                              style={{ fontSize: '12px', fontWeight: 'bold', ml: '60px' }}
                            >
                              Fecha de acceso al documento
                            </p>
                          </div>
                          <div className="d-flex justify-content-center flex-grow-1">
                            <p className="m-0" style={{ fontSize: '12px', fontWeight: 'bold' }}>
                              Acceso al documento
                            </p>
                          </div>
                        </ListGroup.Item>

                        {userPermissions.history &&
                          userPermissions.history.length > 0 &&
                          userPermissions.history.map((history) => (
                            <ListGroup.Item
                              key={history.id}
                              className="d-flex justify-content-between align-items-center"
                              style={{ borderTop: '1px solid #e7e7e7', gap: '20px' }}
                            >
                              <div className="d-flex justify-content-left flex-grow-1 ml-2">
                                <p className="m-0" style={{ fontSize: '11px' }}>
                                  {history.updated_at}
                                </p>
                              </div>
                              <div className="d-flex justify-content-center flex-grow-1">
                                <p className="m-0" style={{ fontSize: '11px' }}>
                                  {history.active ? 'Permitido' : 'Denegado'}
                                </p>
                              </div>
                            </ListGroup.Item>
                          ))}
                      </ListGroup>
                    </Collapse>
                  </div>
                </>
              ))}
            </ListGroup>
          </>
        ) : (
          <div className="text-center pt-4">{document.isNew ? 'HOLA' : 'no hay resultados '}</div>
        )}
      </div>
    </>
  );

  const footerModal = (
    <>
      {(initialHasEnabledPermission ||
        canSaveDocumentWithOutusers ||
        usersPermissions.length === 0) && (
        <Button
          onClick={() => setModalShowing(false)}
          variant="secondary"
          disabled={isLoadingUsersPermissions}
        >
          Cerrar
        </Button>
      )}

      <Button
        onClick={asign && asign.isNew ? () => setShowConfirmModal(true) : onPostUsersPermissions}
        disabled={
          isLoadingUsersPermissions || (!hasEnabledPermission && !canSaveDocumentWithOutusers)
        }
      >
        Guardar
      </Button>
    </>
  );

  useEffect(() => {
    window.history.pushState(null, '', window.location.href);

    const handlePopstate = (event) => {
      window.history.pushState(null, '', window.location.href);
    };

    window.addEventListener('popstate', handlePopstate);

    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, []);

  return (
    <div>
      <ModalComponent
        size="lg"
        header={`Gestionar usuarios con acceso al documento ${
          document.filename ? document.filename : ''
        }`}
        body={bodyModal}
        footer={footerModal}
        show={isModalShowing}
        canClose={initialHasEnabledPermission}
        onHide={initialHasEnabledPermission ? setModalShowing : () => {}}
        scroll={true}
        dialogClassName="users-and-permissions-list-modal"
      />
      {asign && asign.isNew && showConfirmModal && (
        <ModalComponent
          size="lg"
          header={`Atencion!`}
          body={'Asegúrate de dar vista del documento a los usuarios ciudadanos que lo requieran'}
          footer={
            <div>
              <Button
                onClick={() => {
                  setShowConfirmModal(false);
                  onPostUsersPermissions();
                  if (asign.isMultipleSign) {
                    setShowTransferModal(true);
                  }
                }}
                disabled={isLoadingUsersPermissions || !canContinue}
              >
                Aceptar
              </Button>
              {usersPermissions.length === 0 && (
                <Button
                  onClick={() => {
                    setShowConfirmModal(false);
                  }}
                  variant="secondary"
                >
                  Cerrar
                </Button>
              )}
            </div>
          }
          show={isModalShowing}
          canClose
          onHide={setModalShowing}
          scroll={true}
          dialogClassName="users-and-permissions-list-modal"
        />
      )}
    </div>
  );
};

export default UsersAndPermissionsListModal;
